<template>
  <q-page padding>
    <MissionForm 
              v-model:mission="mission"
              button-label="Erstellen"
              @update:date="updateDate"
              @onSubmit="create"
    />
  </q-page>
</template>

<script>
  import MissionForm from '@/components/MissionForm.vue'
  import { createMission } from '@/services/Missions.js'
  import { updateMissionDate } from '@/utils/useDateUtils.js'
  import { Notify } from 'quasar'
  import { apiErrorHandler } from '@/utils/apiErrorHandler.js'
  export default {
    components: { MissionForm },
    data() { 
      return {
        mission: {
          title: "",
          excerpt: "",
          description: "",
          start_date: "",
          end_date: "",
          team_set: []
        }
      }
    }, 
    methods: {
      create() {
        createMission(this.mission)
          .then( response => {
            Notify.create( { 
                message: "Termin angelegt",
                type: "positive"
              } )
            this.$router.replace(`/missions/${response.id}`)
          } )
          .catch(apiErrorHandler("[MissionNew] Mission erstellen"))
      },
      updateDate(d) {
        updateMissionDate(this.mission, d)
      }
    }
  }
</script>
